import { collection, getDocs, query, where } from "firebase/firestore"
import { db } from "../../config/firebase-config"
import ObjectiveCompany from "../../models/ObjectiveCompany"
import MeasureCompany from "../../models/MeasureCompany"

export const getAllCompanyObjectivesAcrossScorecards = async (companyId: string) => {
  const scorecardsPath = `companies/${companyId}/scorecards`
  const scorecardSnapshots = await getDocs(collection(db, scorecardsPath))
  const allObjectives: any[] = []

  for (const scorecardDoc of scorecardSnapshots.docs) {
    const scorecardId = scorecardDoc.id
    const objectivesPath = `companies/${companyId}/scorecards/${scorecardId}/companyObjectives`
    const objectivesSnapshot = await getDocs(collection(db, objectivesPath))

    objectivesSnapshot.forEach((doc) => {
      allObjectives.push({
        ...doc.data(),
        id: doc.id,
        scorecardId,
      })
    })
  }

  return allObjectives
}
export const getCompanyObjectives = async (companyId: string, quarter: string): Promise<ObjectiveCompany[]> => {
  try {
    const objectivesRef = collection(db, "companyObjectives")
    const q = query(objectivesRef, where("companyId", "==", companyId), where("quarter", "==", quarter))
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map((doc) => {
      const data = doc.data()
      // Assuming measures are nested or fetched separately and then combined
      // For this example, we'll mock measures or assume they are part of the objective data
      return { id: doc.id, ...data, measures: data.measures || [] } as unknown as ObjectiveCompany
    })
  } catch (error) {
    console.error("Error fetching company objectives:", error)
    return []
  }
}

export const getCompanyMeasures = async (companyId: string, quarter: string): Promise<MeasureCompany[]> => {
  try {
    const measuresRef = collection(db, "companyMeasures")
    const q = query(measuresRef, where("companyId", "==", companyId), where("quarter", "==", quarter))
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }) as unknown as MeasureCompany)
  } catch (error) {
    console.error("Error fetching company measures:", error)
    return []
  }
}

export const getAllCompanyMeasuresAcrossScorecards = async (companyId: string) => {
  const scorecardsPath = `companies/${companyId}/scorecards`
  const scorecardSnapshots = await getDocs(collection(db, scorecardsPath))
  const allMeasures: any[] = []

  for (const scorecardDoc of scorecardSnapshots.docs) {
    const scorecardId = scorecardDoc.id
    const measuresPath = `companies/${companyId}/scorecards/${scorecardId}/companyMeasures`
    const measuresSnapshot = await getDocs(collection(db, measuresPath))

    measuresSnapshot.forEach((doc) => {
      allMeasures.push({
        ...doc.data(),
        id: doc.id,
        scorecardId,
      })
    })
  }

  return allMeasures
}



